import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface FocusSeshPreset {
  id?: string | number
  isTimed: boolean
  secondsDuration: number | null
  isNoCheckIns: boolean
  isAutoCheckIns: boolean
  checkInTiming: string | null
  checkInChime: string
  startAndEndChime: string
  soundtrack: string
  voiceGuidance: string | null
}

export const selectFocusSeshPresets = (state: any) => state.focusSeshPresets

const initialState: FocusSeshPreset[] = []

const focusSeshPresetsSlice = createSlice({
  name: 'focusSeshPresets',
  initialState,
  reducers: {
    loadFocusSeshPresets: (state, {
      payload: focusSeshPresets,
    }: PayloadAction<FocusSeshPreset[]>) => focusSeshPresets,
    addPreset: (state, {
      payload: focusSeshPreset,
    }: PayloadAction<FocusSeshPreset>) => [focusSeshPreset, ...state],
    deletePreset: (state, {
      payload: presetId,
    }: PayloadAction<string | number>) => {
      if (!presetId) {
        console.error('Error deleting preset. No preset ID provided.')
        return state
      }

      return state.filter((preset) => preset.id !== presetId)
    },
  },
})

export const { loadFocusSeshPresets, addPreset, deletePreset } = focusSeshPresetsSlice.actions

export default focusSeshPresetsSlice.reducer
